<div class="col px-lg-5 px-2">
	<app-nav-gestion-donnees class="row my-5"></app-nav-gestion-donnees>

	<div *ngIf="synchronizedEvent" class="row my-3 theme-main-color">
		<div class="row">
			<div class="d-flex justify-content-between">
				<div class="hand-cursor">
					<span (click)="goBack()" class="fs-4"
						><em class="bi bi-arrow-left me-3"></em
						>{{ 'Réunion' | titlecase }}</span
					>
				</div>

				<div *ngIf="isDeletable" class="">
					<a
						(click)="openConfirmDeleteModal(deleteArea)"
						class="btn theme-red-button px-4"
					>
						Supprimer la réunion
					</a>
				</div>
			</div>
			<div class="row my-5">
				<span class="fw-bold fs-5">Informations</span>
			</div>
		</div>
		<div class="row rounded bg-light">
			<div *ngIf="isFormReadOnly">
				<div class="row my-4">
					<div class="col">
						<label for="inputArea" class="form-label theme-main-color fw-bold"
							>Organisateur.trice</label
						>
						<span class="form-control-plaintext">{{
							synchronizedEvent.planner.firstName +
								' ' +
								synchronizedEvent.planner.lastName
						}}</span>
					</div>
				</div>
				<div class="row my-4">
					<div class="col">
						<label for="inputArea" class="form-label theme-main-color fw-bold"
							>Date</label
						>
						<span class="form-control-plaintext">{{
							synchronizedEvent.missionRequest.date | date: 'dd/MM/YYYY'
						}}</span>
					</div>
					<div class="col">
						<label for="inputArea" class="form-label theme-main-color fw-bold"
							>Heure de début:
						</label>
						<span class="form-control-plaintext">{{
							this.startDateWithHours | date: 'HH:mm'
						}}</span>
					</div>
					<div class="col">
						<label for="inputArea" class="form-label theme-main-color fw-bold"
							>Heure de fin:</label
						>
						<span class="form-control-plaintext">{{
							this.endDateWithHours | date: 'HH:mm'
						}}</span>
					</div>
				</div>
				<div class="row my-4">
					<div class="col">
						<label
							for="inputParticipant"
							class="form-label theme-main-color fw-bold"
							>Participants</label
						>
						<span class="form-control-plaintext">
							<p *ngFor="let attendee of synchronizedEvent.attendees">
								{{ attendee.firstName + ' ' + attendee.lastName }}
							</p>
						</span>
					</div>
				</div>
				<div class="row my-4">
					<div class="col">
						<label for="inputNotes" class="form-label theme-main-color fw-bold"
							>Notes</label
						>
						<span class="form-control-plaintext">
							<p>
								{{ synchronizedEvent.missionRequest.notes }}
							</p>
						</span>
					</div>
				</div>
			</div>

			<app-meeting-form
				*ngIf="!isFormReadOnly"
				[synchronizedEvent]="synchronizedEventModifiedInForm"
				[meetingForm]="meetingDetailForm"
				(sendForm)="onSubmit()"
			></app-meeting-form>
		</div>
		<div class="row my-4">
			<div class="d-flex justify-content-end">
				<button
					*ngIf="isFormReadOnly"
					class="btn theme-main-color-button"
					(click)="editForm()"
				>
					<i class="bi bi-pencil-fill px-1" aria-hidden="true"></i>Modifier les
					informations
				</button>
				<button
					*ngIf="!isFormReadOnly"
					class="btn theme-main-color-button mx-3 px-3"
					(click)="stopEditForm()"
				>
					Annuler
				</button>
				<button
					*ngIf="!isFormReadOnly"
					[disabled]="!meetingDetailForm.valid || isValidateButtonClicked.value"
					class="btn theme-green-button"
					type="submit"
					form="form"
					(click)="onSubmit()"
				>
					<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
				</button>
			</div>
		</div>
	</div>
</div>

<ng-template #deleteArea>
	<div class="modal-header text-center">
		<h4>Suppression</h4>
		<button
			type="button"
			class="btn-close"
			data-bs-dismiss="modal"
			aria-label="Close"
			(click)="confirmDeleteModalRef.hide()"
		>
			<span aria-hidden="true"></span>
		</button>
	</div>
	<div class="modal-body">
		Êtes-vous sûr de vouloir supprimer cette réunion ?
	</div>
	<div class="modal-footer">
		<a
			(click)="confirmDeleteModalRef.hide()"
			class="btn theme-main-color-button"
			>Retour</a
		>
		<a class="btn theme-red-button ms-3" (click)="deleteMeeting()">Supprimer</a>
	</div>
</ng-template>
